import { createSlice } from "@reduxjs/toolkit";

export const forgotSlice = createSlice({
  name: 'forgot',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startForgot: (state) => { state.isLoading = true; },
    setForgot: (state, { payload: { data = null, error = null } = {}} = {}) => { 
      state.data = data ?? null;
      state.error = error ?? null;
      state.isLoading = false;
    }
  }
});

export const { startForgot, setForgot } = forgotSlice.actions;
